import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceWorker from "./serviceWorker";

import App from "./App";
import "./styles/mobileApp.css";

// ✅ Protección contra traductores del navegador (Google Translate, etc.):
// reemplazan nodos de texto y React falla con "removeChild/insertBefore: el nodo no es hijo".
if (typeof Node === "function" && Node.prototype) {
	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function (child) {
		if (child.parentNode !== this) {
			if (child.parentNode) return child.parentNode.removeChild(child);
			return child;
		}
		return originalRemoveChild.apply(this, arguments);
	};
	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function (newNode, referenceNode) {
		if (referenceNode && referenceNode.parentNode !== this) {
			return originalInsertBefore.call(this, newNode, null);
		}
		return originalInsertBefore.apply(this, arguments);
	};
}

// ✅ Estilos globales para eliminar scroll innecesario del body/html
const globalStyles = `
  html, body, #root {
    height: 100%;
    height: 100dvh;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
`;

// ✅ Inyectar estilos globales
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

serviceWorker.register();
